import lrModifyuser from './_src/lrModifyuser.vue'
lrModifyuser.install = function(Vue) {
  Vue.component(lrModifyuser.name, lrModifyuser)
}
export default lrModifyuser